export default __webpack_public_path__ + "static/media/719.4cd4e3fb.gif";